/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import Object from 'apmui/util/Object';
import { RESOURCE } from 'apmui/resource/ResourceType';
import WebtopSectionView from 'apmui/resource/webtopSection/View';
import bind from 'apmui/decorators/bind';
import throttle from 'apmui/decorators/throttle';
import WebtopFolderView from 'apmui/resource/webtopFolder/View';

import IWebtopModel from './Model';
import SearchView from './SearchView';
import UrlInputView from './UrlView';

class WebtopView extends React.Component<IWebtopModel> {
    state = { searchPattern: '' };

    // search for resources in each section
    @bind
    @throttle(400)
    onSearchPatternChange(pattern: string) {
        console.log(`searchRun(${pattern})`);
        if (this.state.searchPattern !== pattern) {
            this.setState({ searchPattern: pattern });
        }
    }

    renderSections() {
        const resources = this.props[this.props.pageType].resources;
        if (!resources) {
            return;
        }
        const sections = resources[RESOURCE.WEBTOP_SECTION];
        if (!sections) {
            return;
        }
        const sortedSections = Object.values(sections)
            .filter((section) => section.assignedResources.length)
            .sort((a, b) => {
                return a.order - b.order;
            });
        const sectionViews = sortedSections.map((section) => {
            return (
                <WebtopSectionView
                    key={section.id}
                    section={section}
                    resources={resources}
                    searchPattern={this.state.searchPattern}
                />
            );
        });
        return sectionViews;
    }

    renderFolderBrowser() {
        if (typeof this.props.webtop.activeFolder !== 'string') {
            return;
        }
        const resources = this.props.webtop.resources;
        if (!resources) {
            return;
        }
        const folders = resources[RESOURCE.WEBTOP_FOLDER];
        if (!folders) {
            return;
        }
        const folder = folders[this.props.webtop.activeFolder];
        if (!folder) {
            return;
        }
        return <WebtopFolderView folder={folder} modal resources={resources} />;
    }

    renderToolbar() {
        const webtop = this.props[this.props.pageType];
        return (
            <div id="webtop-toolbar">
                {webtop.config.search.enabled === '1' && (
                    <SearchView search={webtop.config.search} onChange={this.onSearchPatternChange} />
                )}
            </div>
        );
    }

    renderUrlToolbar() {
        const webtop = this.props[this.props.pageType];
        return (
            <div className="header-toolbar">
                {webtop.config.urlInput.enabled === '1' && <UrlInputView {...webtop.config.urlInput} />}
            </div>
        );
    }

    render() {
        const sections = this.renderSections();
        const toolbar = this.renderToolbar();
        const urlToolbar = this.renderUrlToolbar();
        const folderBrowser = this.renderFolderBrowser();
        return (
            <div className="apmui-webtop-content">
                {urlToolbar}
                {toolbar}
                {folderBrowser}
                {sections}
            </div>
        );
    }
}

export { WebtopView as default, WebtopView };
